import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "div"
};
import { ColorEnum } from "@/modules/vue/enums";
import SimpleActionSheetItem from "@/modules/vue/components/SimpleActionSheetItem.vue";
import { Team } from "@/modules/team/entity";
export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleActionSheetBuyItem',
  props: {
    price: null
  },
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const team = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      team.value = await Team.current();
    })), __temp = await __temp, __restore(), __temp);
    const canBuy = computed(() => team.value.balance >= props.price);
    const color = computed(() => canBuy.value ? ColorEnum.Green : ColorEnum.Red);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(SimpleActionSheetItem, _mergeProps(_ctx.$attrs, {
        color: _unref(color),
        disabled: !_unref(canBuy)
      }), {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('buy_for_x_price', {
          price: _ctx.$money(__props.price)
        })), 1)]),
        _: 1
      }, 16, ["color", "disabled"]);
    };
  }
});